import {CustomerState} from "@/Enums";
import {useI18n} from "@/composables/useI18n";
const useCustomerStateMap = () => {

    const {
        t,
    } = useI18n();

    const customerStateMap = {
        [CustomerState.Interested]: t('state_interested'),
        [CustomerState.Contracted]: t('state_contracted'),
        [CustomerState.Confirmed]: t('state_confirmed'),
        [CustomerState.Canceled]: t('state_canceled')
    }

    return {
        customerStateMap
    }
}


export {
    useCustomerStateMap
}

